import React, {
  useMemo,
  useState,
  useImperativeHandle,
  useEffect,
} from 'react';
import styled from 'styled-components';
import TrueImpactText from 'shared/design-system/base/TrueImpactText';
import { FeedbackQuestionHandler, FeedbackSectionInfo } from '../utils';
import { SelectorOptions } from 'shared/design-system/components/Selector';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';
import {
  getQuestionOptions,
  serviceDeliveryQuestionId,
  serviceSubTypeQuestionId,
} from '../../../ReportBuilder/Components/Activities/options';
import { FeedbackQuestionsById, FeedbackQuestion } from '../api';

const getActivitiesOptions = (
  questions: FeedbackQuestionsById,
  question: FeedbackQuestion,
) => {
  const serviceDelivery =
    questions[serviceDeliveryQuestionId]?.answers[0]?.text;
  const serviceSubType = questions[serviceSubTypeQuestionId]?.answers[0]?.text;
  const questionOptions = getQuestionOptions(
    question.dbId,
    serviceDelivery,
    serviceSubType,
  );
  return questionOptions?.options || [];
};

const StyledDiv = styled.div``;

const defaultGetLabel = (value: string) => value;

const RadioSection = React.forwardRef<
  FeedbackQuestionHandler,
  FeedbackSectionInfo
>(
  (
    {
      reportId,
      questionId,
      answer,
      questionText,
      question,
      questions,
      selectedSection,
    },
    forwardRef,
  ) => {
    const [selected, setSelected] = useState<string>(answer);

    useEffect(() => {
      setSelected(answer);
    }, [questionId]);

    const options = useMemo(() => {
      if (selectedSection.section.sectionId === 'activities') {
        return getActivitiesOptions(questions, question);
      }
      return question.enumResponses.map(o => o.response);
    }, [question.enumResponses]);

    useImperativeHandle(forwardRef, () => ({
      reportId,
      questionId,
      answer: () => selected,
      errorText: () =>
        selected ? undefined : 'Please select one of the options',
    }));

    return (
      <StyledDiv>
        <TrueImpactText variant="heading-subheading" className="question-text">
          {questionText}
        </TrueImpactText>
        <SelectorOptions
          variant="radio"
          padding={SPACERS.tiny}
          options={options}
          getLabel={defaultGetLabel}
          getSelected={val => selected === val}
          onClick={setSelected}
        />
      </StyledDiv>
    );
  },
);

export default RadioSection;
